export default [
  "PST8PDT",
  "Indian/Mauritius",
  "Indian/Mahe",
  "Indian/Antananarivo",
  "Indian/Comoro",
  "Indian/Christmas",
  "Indian/Kerguelen",
  "Indian/Chagos",
  "Indian/Reunion",
  "Indian/Cocos",
  "Indian/Maldives",
  "Indian/Mayotte",
  "Antarctica/Troll",
  "Antarctica/Syowa",
  "Antarctica/Mawson",
  "Antarctica/Vostok",
  "Antarctica/Casey",
  "Antarctica/DumontDUrville",
  "Antarctica/Rothera",
  "Antarctica/Davis",
  "Antarctica/Palmer",
  "Antarctica/McMurdo",
  "Antarctica/Macquarie",
  "Europe/Kirov",
  "Europe/Vilnius",
  "Europe/Helsinki",
  "Europe/Budapest",
  "Europe/Busingen",
  "Europe/Volgograd",
  "Europe/Skopje",
  "Europe/Paris",
  "Europe/Jersey",
  "Europe/Oslo",
  "Europe/Prague",
  "Europe/Zurich",
  "Europe/Dublin",
  "Europe/Saratov",
  "Europe/Belfast",
  "Europe/Tallinn",
  "Europe/Monaco",
  "Europe/Bucharest",
  "Europe/Brussels",
  "Europe/Athens",
  "Europe/Amsterdam",
  "Europe/Copenhagen",
  "Europe/Mariehamn",
  "Europe/Kyiv",
  "Europe/Gibraltar",
  "Europe/Astrakhan",
  "Europe/Tiraspol",
  "Europe/Malta",
  "Europe/Tirane",
  "Europe/Minsk",
  "Europe/Vatican",
  "Europe/Ulyanovsk",
  "Europe/Podgorica",
  "Europe/Guernsey",
  "Europe/Rome",
  "Europe/Zagreb",
  "Europe/Belgrade",
  "Europe/London",
  "Europe/Madrid",
  "Europe/San_Marino",
  "Europe/Kaliningrad",
  "Europe/Chisinau",
  "Europe/Vaduz",
  "Europe/Istanbul",
  "Europe/Warsaw",
  "Europe/Andorra",
  "Europe/Luxembourg",
  "Europe/Ljubljana",
  "Europe/Lisbon",
  "Europe/Nicosia",
  "Europe/Moscow",
  "Europe/Sarajevo",
  "Europe/Sofia",
  "Europe/Berlin",
  "Europe/Isle_of_Man",
  "Europe/Samara",
  "Europe/Stockholm",
  "Europe/Simferopol",
  "Europe/Vienna",
  "Europe/Bratislava",
  "Europe/Riga",
  "Asia/Kashgar",
  "Asia/Chita",
  "Asia/Chongqing",
  "Asia/Makassar",
  "Asia/Kuching",
  "Asia/Aqtau",
  "Asia/Tbilisi",
  "Asia/Amman",
  "Asia/Kuala_Lumpur",
  "Asia/Tehran",
  "Asia/Kathmandu",
  "Asia/Thimphu",
  "Asia/Novosibirsk",
  "Asia/Bishkek",
  "Asia/Pontianak",
  "Asia/Tokyo",
  "Asia/Brunei",
  "Asia/Krasnoyarsk",
  "Asia/Shanghai",
  "Asia/Omsk",
  "Asia/Hong_Kong",
  "Asia/Aden",
  "Asia/Bangkok",
  "Asia/Barnaul",
  "Asia/Qostanay",
  "Asia/Vladivostok",
  "Asia/Famagusta",
  "Asia/Seoul",
  "Asia/Dubai",
  "Asia/Kabul",
  "Asia/Yakutsk",
  "Asia/Taipei",
  "Asia/Ho_Chi_Minh",
  "Asia/Yerevan",
  "Asia/Phnom_Penh",
  "Asia/Urumqi",
  "Asia/Beirut",
  "Asia/Dili",
  "Asia/Karachi",
  "Asia/Yangon",
  "Asia/Tomsk",
  "Asia/Gaza",
  "Asia/Manila",
  "Asia/Qyzylorda",
  "Asia/Atyrau",
  "Asia/Kolkata",
  "Asia/Vientiane",
  "Asia/Macau",
  "Asia/Jerusalem",
  "Asia/Samarkand",
  "Asia/Tel_Aviv",
  "Asia/Almaty",
  "Asia/Irkutsk",
  "Asia/Damascus",
  "Asia/Novokuznetsk",
  "Asia/Pyongyang",
  "Asia/Srednekolymsk",
  "Asia/Hebron",
  "Asia/Yekaterinburg",
  "Asia/Magadan",
  "Asia/Muscat",
  "Asia/Tashkent",
  "Asia/Dushanbe",
  "Asia/Riyadh",
  "Asia/Baku",
  "Asia/Ust-Nera",
  "Asia/Harbin",
  "Asia/Jakarta",
  "Asia/Singapore",
  "Asia/Hovd",
  "Asia/Aqtobe",
  "Asia/Bahrain",
  "Asia/Khandyga",
  "Asia/Istanbul",
  "Asia/Oral",
  "Asia/Dhaka",
  "Asia/Kuwait",
  "Asia/Anadyr",
  "Asia/Ulaanbaatar",
  "Asia/Nicosia",
  "Asia/Sakhalin",
  "Asia/Colombo",
  "Asia/Jayapura",
  "Asia/Qatar",
  "Asia/Kamchatka",
  "Asia/Ashgabat",
  "Asia/Choibalsan",
  "Asia/Baghdad",
  "EST5EDT",
  "HST",
  "America/Hermosillo",
  "America/Curacao",
  "America/Detroit",
  "America/El_Salvador",
  "America/Belem",
  "America/St_Vincent",
  "America/Ensenada",
  "America/Phoenix",
  "America/Anchorage",
  "America/Inuvik",
  "America/Nome",
  "America/Monterrey",
  "America/Jamaica",
  "America/Denver",
  "America/Kentucky/Monticello",
  "America/Kentucky/Louisville",
  "America/Lower_Princes",
  "America/Ojinaga",
  "America/Marigot",
  "America/Tegucigalpa",
  "America/Nuuk",
  "America/Lima",
  "America/Cancun",
  "America/Miquelon",
  "America/Port-au-Prince",
  "America/Guadeloupe",
  "America/Whitehorse",
  "America/Vancouver",
  "America/Boise",
  "America/Montserrat",
  "America/Blanc-Sablon",
  "America/St_Thomas",
  "America/Porto_Acre",
  "America/St_Kitts",
  "America/Caracas",
  "America/Resolute",
  "America/Cambridge_Bay",
  "America/Grand_Turk",
  "America/Mazatlan",
  "America/Nipigon",
  "America/Managua",
  "America/Los_Angeles",
  "America/Glace_Bay",
  "America/Aruba",
  "America/Punta_Arenas",
  "America/Boa_Vista",
  "America/Tijuana",
  "America/Maceio",
  "America/Atka",
  "America/Manaus",
  "America/Porto_Velho",
  "America/Campo_Grande",
  "America/New_York",
  "America/Santiago",
  "America/Havana",
  "America/Montreal",
  "America/St_Johns",
  "America/Recife",
  "America/Guatemala",
  "America/Cayenne",
  "America/Cuiaba",
  "America/Toronto",
  "America/Mexico_City",
  "America/Yakutat",
  "America/Menominee",
  "America/Paramaribo",
  "America/Chicago",
  "America/Fortaleza",
  "America/Bahia_Banderas",
  "America/St_Lucia",
  "America/Rankin_Inlet",
  "America/North_Dakota/Center",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/New_Salem",
  "America/Tortola",
  "America/La_Paz",
  "America/Thunder_Bay",
  "America/Antigua",
  "America/Thule",
  "America/Chihuahua",
  "America/Merida",
  "America/Bogota",
  "America/Guayaquil",
  "America/Halifax",
  "America/Shiprock",
  "America/Santo_Domingo",
  "America/Bahia",
  "America/Swift_Current",
  "America/Juneau",
  "America/Rainy_River",
  "America/Costa_Rica",
  "America/Indiana/Winamac",
  "America/Indiana/Tell_City",
  "America/Indiana/Vincennes",
  "America/Indiana/Knox",
  "America/Indiana/Indianapolis",
  "America/Indiana/Vevay",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Guyana",
  "America/Anguilla",
  "America/Metlakatla",
  // "America/Coyhaique",
  "America/Pangnirtung",
  "America/Kralendijk",
  "America/Nassau",
  "America/Ciudad_Juarez",
  "America/Goose_Bay",
  "America/Grenada",
  "America/Matamoros",
  "America/Montevideo",
  "America/Araguaina",
  "America/Sao_Paulo",
  "America/Panama",
  "America/Port_of_Spain",
  "America/Sitka",
  "America/Santa_Isabel",
  "America/Creston",
  "America/Regina",
  "America/Asuncion",
  "America/Virgin",
  "America/Dawson",
  "America/Cayman",
  "America/Winnipeg",
  "America/Fort_Nelson",
  "America/Edmonton",
  "America/Coral_Harbour",
  "America/Adak",
  "America/Atikokan",
  "America/Santarem",
  "America/Eirunepe",
  "America/Yellowknife",
  "America/Puerto_Rico",
  "America/Scoresbysund",
  "America/St_Barthelemy",
  "America/Iqaluit",
  "America/Dominica",
  "America/Rio_Branco",
  "America/Argentina/Mendoza",
  "America/Argentina/San_Luis",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Cordoba",
  "America/Argentina/Tucuman",
  "America/Argentina/Jujuy",
  "America/Argentina/San_Juan",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/La_Rioja",
  "America/Argentina/Salta",
  "America/Argentina/Ushuaia",
  "America/Argentina/Catamarca",
  "America/Dawson_Creek",
  "America/Noronha",
  "America/Danmarkshavn",
  "America/Barbados",
  "America/Martinique",
  "America/Belize",
  "America/Moncton",
  "Australia/Eucla",
  "Australia/Lord_Howe",
  "Australia/Lindeman",
  "Australia/Melbourne",
  "Australia/Darwin",
  "Australia/Broken_Hill",
  "Australia/Currie",
  "Australia/Canberra",
  "Australia/Yancowinna",
  "Australia/Perth",
  "Australia/Adelaide",
  "Australia/Brisbane",
  "Australia/Hobart",
  "Australia/Sydney",
  "Atlantic/South_Georgia",
  "Atlantic/Canary",
  "Atlantic/Jan_Mayen",
  "Atlantic/Madeira",
  "Atlantic/Bermuda",
  "Atlantic/Reykjavik",
  "Atlantic/Stanley",
  "Atlantic/Faroe",
  "Atlantic/Azores",
  "Atlantic/St_Helena",
  "Atlantic/Cape_Verde",
  "Arctic/Longyearbyen",
  "UTC",
  "MST7MDT",
  "Etc/GMT-11",
  "Etc/GMT+1",
  "Etc/GMT-9",
  "Etc/GMT-12",
  "Etc/UCT",
  "Etc/GMT-5",
  "Etc/GMT-7",
  "Etc/GMT+3",
  "Etc/GMT+8",
  "Etc/GMT0",
  "Etc/UTC",
  "Etc/GMT-6",
  "Etc/GMT+7",
  "Etc/GMT+10",
  "Etc/GMT-0",
  "Etc/GMT+9",
  "Etc/GMT+12",
  "Etc/GMT-13",
  "Etc/GMT+5",
  "Etc/GMT+0",
  "Etc/GMT-2",
  "Etc/Greenwich",
  "Etc/Zulu",
  "Etc/GMT-14",
  "Etc/GMT-4",
  "Etc/GMT+2",
  "Etc/GMT-3",
  "Etc/GMT-10",
  "Etc/GMT+11",
  "Etc/GMT+6",
  "Etc/GMT-1",
  "Etc/GMT-8",
  "Etc/GMT+4",
  "Etc/GMT",
  "Etc/Universal",
  "WET",
  "EET",
  "CET",
  "MET",
  // "Factory",
  "CST6CDT",
  "Africa/Maputo",
  "Africa/Casablanca",
  "Africa/Cairo",
  "Africa/Niamey",
  "Africa/Bangui",
  "Africa/Khartoum",
  "Africa/Tunis",
  "Africa/Nairobi",
  "Africa/Tripoli",
  "Africa/Ceuta",
  "Africa/Gaborone",
  "Africa/Maseru",
  "Africa/Asmara",
  "Africa/Juba",
  "Africa/Libreville",
  "Africa/Porto-Novo",
  "Africa/Kinshasa",
  "Africa/Brazzaville",
  "Africa/Lome",
  "Africa/Accra",
  "Africa/Dakar",
  "Africa/Luanda",
  "Africa/Nouakchott",
  "Africa/El_Aaiun",
  "Africa/Lubumbashi",
  "Africa/Windhoek",
  "Africa/Ndjamena",
  "Africa/Freetown",
  "Africa/Bissau",
  "Africa/Kampala",
  "Africa/Ouagadougou",
  "Africa/Dar_es_Salaam",
  "Africa/Abidjan",
  "Africa/Douala",
  "Africa/Blantyre",
  "Africa/Bujumbura",
  "Africa/Harare",
  "Africa/Banjul",
  "Africa/Mogadishu",
  "Africa/Johannesburg",
  "Africa/Djibouti",
  "Africa/Sao_Tome",
  "Africa/Bamako",
  "Africa/Kigali",
  "Africa/Timbuktu",
  "Africa/Mbabane",
  "Africa/Addis_Ababa",
  "Africa/Conakry",
  "Africa/Algiers",
  "Africa/Lagos",
  "Africa/Lusaka",
  "Africa/Monrovia",
  "Africa/Malabo",
  "Pacific/Kanton",
  "Pacific/Kiritimati",
  "Pacific/Kosrae",
  "Pacific/Pohnpei",
  "Pacific/Palau",
  "Pacific/Niue",
  "Pacific/Midway",
  "Pacific/Rarotonga",
  "Pacific/Galapagos",
  "Pacific/Wake",
  "Pacific/Noumea",
  "Pacific/Guam",
  "Pacific/Pitcairn",
  "Pacific/Tongatapu",
  "Pacific/Tarawa",
  "Pacific/Easter",
  "Pacific/Bougainville",
  "Pacific/Norfolk",
  "Pacific/Guadalcanal",
  "Pacific/Majuro",
  "Pacific/Fiji",
  "Pacific/Auckland",
  "Pacific/Marquesas",
  "Pacific/Nauru",
  "Pacific/Gambier",
  "Pacific/Honolulu",
  "Pacific/Port_Moresby",
  "Pacific/Apia",
  "Pacific/Pago_Pago",
  "Pacific/Chuuk",
  "Pacific/Samoa",
  "Pacific/Efate",
  "Pacific/Johnston",
  "Pacific/Tahiti",
  "Pacific/Wallis",
  "Pacific/Yap",
  "Pacific/Chatham",
  "Pacific/Fakaofo",
  "Pacific/Saipan",
  "Pacific/Funafuti",
  "Pacific/Kwajalein",
  // "posixrules",
  // "localtime",
  "EST",
  "GMT",
  "MST"
]
